module.exports = __webpack_public_path__ + "roboto-v15-latin-300.94b44971e65de4a45828.svg";


//////////////////
// WEBPACK FOOTER
// A:/CM/links-ui/cm-ui-app-links/src/assets/layout/fonts/roboto-v15-latin-300.svg
// module id = ../../../../../src/assets/layout/fonts/roboto-v15-latin-300.svg
// module chunks = styles